import React from 'react'
import Text from 'react-text'
import {faUsers, faCalendarAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Consumer} from '../../context'
import './tab-bar.styl'

export default function TabBar({activeTab, setState}) {
  const setActiveTab = activeTab => setState({activeTab}) 
  const buttonClassName = tab => `${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`
  const onClick = tab => () => (activeTab != tab) && setActiveTab(tab)
  return (
    <div className="tab-bar">
      <div className={buttonClassName('groups')} onClick={onClick('groups')}>
        <FontAwesomeIcon icon={faUsers} />
        <Text id='schedule_lesson_group_button_label' /> 
      </div>
      <div className={buttonClassName('date')} onClick={onClick('date')}>
        <FontAwesomeIcon icon={faCalendarAlt} />
        <Text id='schedule_lesson_date_button_label' /> 
      </div>
    </div>
  )
}
